import l10n from "@/services/l10n";
import AccessControl from "@/services/AccessControl";

import { USER_GROUP_PERSON } from "@/constants";

export default [
  {
    name: "tracks",
    path: "/",
    alias: "/tracks",
    icon: "tracks",
    meta: { title: l10n("TRACKS") },
    component: () =>
      import(/* webpackChunkName: "showcase" */ "@/pages/Tracks/Tracks.vue")
  },
  {
    name: "popularTracks",
    path: "/tracks/popular",
    icon: "tracks",
    meta: { title: l10n("POPULAR_TRACKS") },
    component: () =>
      import(
        /* webpackChunkName: "tracks-list" */ "@/pages/Tracks/TracksPopular.vue"
      )
  },
  {
    name: "popularTracksChart",
    path: "/tracks/popular/chart",
    icon: "tracks",
    meta: { title: l10n("TOP_100_POPULAR_TRACKS") },
    component: () =>
      import(
        /* webpackChunkName: "tracks-list" */ "@/pages/Tracks/TracksPopularChart.vue"
      )
  },
  {
    name: "favoriteTracks",
    path: "/tracks/favorite",
    icon: "tracks",
    meta: { title: l10n("FAVORITES_TRACKS") },
    beforeEnter: AccessControl.route(USER_GROUP_PERSON),
    component: () =>
      import(
        /* webpackChunkName: "tracks-list" */ "@/pages/Tracks/TracksFavorite.vue"
      )
  },
  {
    name: "favoriteTracksChart",
    path: "/tracks/favorite/chart",
    icon: "tracks",
    meta: { title: l10n("TOP_100_LIKED_TRACKS") },
    component: () =>
      import(
        /* webpackChunkName: "tracks-list" */ "@/pages/Tracks/TracksFavoriteChart.vue"
      )
  },
  {
    name: "latestTracks",
    path: "/tracks/latest",
    icon: "tracks",
    meta: { title: l10n("NEW_RELEASES") },
    component: () =>
      import(
        /* webpackChunkName: "tracks-list" */ "@/pages/Tracks/TracksLatest.vue"
      )
  },
  {
    name: "trackEdit",
    path: "/tracks/:id/edit",
    icon: "tracks",
    meta: { title: l10n("EDIT_TRACK") },
    // beforeEnter: authenticatedAlbumOwner,
    component: () =>
      import(/* webpackChunkName: "editor" */ "@/pages/Tracks/TrackEdit.vue")
  },
  {
    name: "track",
    path: "/tracks/:id",
    icon: "tracks",
    meta: { title: l10n("TRACK") },
    component: () =>
      import(/* webpackChunkName: "fullview" */ "@/pages/Tracks/Track.vue")
  }
];
